<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.organizationName"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('organization_name_hint')"
                :label="$t('organization_name')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-organizationName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('organization_name')"
              />
            </div>
          </v-col>
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.subOrgan"
                append-icon="mdi-domain"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('sub_organization_hint')"
                :label="$t('sub_organization_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-subOrgan`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('sub_organization_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.userName"
                append-icon="mdi-account"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('user_name_hint')"
                :label="$t('user_name_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-userName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('user_name_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.workField"
                append-icon="mdi-domain"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('work_field_hint')"
                :label="$t('work_field_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-workField`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('work_field_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <template v-for="(item, index) in data.phoneNumber">
              <div
                class="rowinfo"
                v-if="!phoneNumberText.includes(index)"
                :key="index"
              >
                <v-text-field
                  v-if="!phoneNumberText.includes(index)"
                  v-model="item.number"
                  clearable
                  dense
                  dir="ltr"
                  class="contentinfo"
                  :hint="$t('mobile_number_hint')"
                  :label="$t('mobile_number_label')"
                  outlined
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                          >mdi-phone</v-icon
                        >
                      </template>
                      {{ $t("number_label") }}
                    </v-tooltip>

                    <v-icon @click="addPhone">mdi-plus</v-icon>
                    <v-icon
                      v-if="data.phoneNumber?.length > 1"
                      @click="removePhone(index)"
                      >mdi-delete</v-icon
                    >
                  </template>
                </v-text-field>
                <help-info
                  v-show="index === 0"
                  :element-name="`${serviceName}-${componentName}-data-phoneNumberText`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('number_label')"
                />
              </div>
              <div class="rowinfo" v-else :key="index">
                <v-text-field
                  v-model="item.text"
                  clearable
                  dense
                  :label="$t('text_label')"
                  outlined
                  class="contentinfo"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                          >mdi-text</v-icon
                        >
                      </template>
                      {{ $t("text_label") }}
                    </v-tooltip>
                  </template>
                </v-text-field>
                <help-info
                  v-show="index === 0"
                  :element-name="`${serviceName}-${componentName}-data-item-text`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('text_label')"
                />
              </div>
            </template>
          </v-col>

          <v-col v-if="containFields" class="pa-md-3" cols="12" md="6">
            <div class="rowinfo" v-if="!showCompanyNumberName">
              <v-text-field
                v-if="!showCompanyNumberName"
                v-model="data.companyNumber"
                clearable
                counter="20"
                class="contentinfo"
                dense
                :hint="$t('phone_number_hint')"
                :label="$t('phone_number_label')"
                maxLength="20"
                outlined
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = true"
                        v-on="on"
                        >mdi-phone</v-icon
                      >
                    </template>
                    {{ $t("phone_number_label") }}
                  </v-tooltip>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumber`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('phone_number_label')"
              />
            </div>
            <div class="rowinfo" v-else>
              <v-text-field
                v-model="data.companyNumberName"
                clearable
                dense
                :label="$t('text_label')"
                outlined
                class="contentinfo"
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = false"
                        v-on="on"
                        >mdi-text</v-icon
                      >
                    </template>
                    {{ $t("text_label") }}
                  </v-tooltip>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumberName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('text_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.email"
                append-icon="mdi-email"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('email_hint')"
                :label="$t('email_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-email`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('email_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.fax"
                append-icon="mdi-domain"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('fax_hint')"
                :label="$t('fax_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-fax`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('fax_label')"
              />
            </div>
          </v-col>
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.website"
                append-icon="mdi-web"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                :rules="urlRules"
                counter="50"
                dense
                :hint="$t('website_hint')"
                :label="$t('website_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-website`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('website_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.codePostal"
                append-icon="mdi-post"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('postal_code_hint')"
                :label="$t('postal_code_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-codePostal`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('postal_code_label')"
              />
            </div>
          </v-col>

          <v-col
            v-if="
              !['qr.create.cardVisitProModel',
              'qr.create.visitcardpro','qr.cardVisit',
               'qr.name.edit', 'qr.name.id.edit',
               'qr.cardVisitPro','qr.name.edit.pro',
               'qr.create.cardVisitProModel','qr.create.visitcardpro',
               'qr.name.id.edit.pro'].includes(
                $route.name,
              )
            "
            class="pa-md-3"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.copyright"
                append-icon="mdi-copyright"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="100"
                dense
                :hint="$t('copyright_hint')"
                :label="$t('copyright_label')"
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-copyright`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('copyright_label')"
              />
            </div>
          </v-col>
        </v-row>

        <v-card-title class="pb-0">
          {{ $t("add_more_info") }}
        </v-card-title>
        <v-divider />

        <extra-fileds v-model="data.extraFields" block />

        <v-row no-gutters>
          <v-col class="py-3 px-md-3" cols="12">
            <v-divider />
            <div class="rowinfo">
              <v-textarea
                v-model="data.location"
                append-icon="mdi-map-marker"
                class="mx-0 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :hint="$t('address_hint')"
                :label="$t('address_label')"
                outlined
                rows="3"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-location`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('address_label')"
              />
            </div>
            <div class="d-flex align-center flex-column flex-md-row">
              <div
                class="rowinfo flex"
                :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
              >
                <v-btn
                  class="text-white flex contentinfo"
                  :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
                  color="indigo"
                  large
                  @click="showMap = true"
                >
                  <v-icon color="red">mdi-map-marker</v-icon>
                  {{
                    data.coordinates ? $t("edit_location") : $t("add_location")
                  }}
                  {{ $t("location") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-showmap`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('location')"
                />
              </div>
              <div
                class="rowinfo"
                :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
              >
                <v-btn
                  v-show="data?.coordinates"
                  class="ms-md-2 mt-2 mt-md-0"
                  :style="$vuetify.breakpoint.mobile ? 'flex: 1 1 auto' : ''"
                  color="red"
                  large
                  outlined
                  @click="removeLocation"
                >
                  <v-icon class="me-2">mdi-close-circle-outline</v-icon>
                  {{ $t("delete_location") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-coordinates`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('delete_location')"
                />
              </div>
            </div>
            <!-- <div class="rowinfo mt-2"> -->
            <!-- <v-btn
                v-show="data?.coordinates"
                class="text-white"
                color="blue"
                large
                @click="openNavigator"
              >
                <v-icon class="me-2">mdi-navigation</v-icon>
                {{ $t("select_navigator_after_location_click") }}
              </v-btn> -->
            <!-- </div> -->
            <v-divider />
          </v-col>

          <v-col class="pa-md-3" cols="12">
            <div class="rowinfo d-flex row flex-nowrap">
              <div
                class="contentinfo"
                :style="$vuetify.breakpoint.mobile ? 'padding-right:10px' : ''"
              >
                <suggest-text
                  v-model="data.aboutUs"
                  :label="$t('suggestinput.aboutUs')"
                  rows="10"
                  :prompt="data.organizationName || data.visitName"
                />
              </div>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-aboutUs`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('about_us_label')"
              />
            </div>
          </v-col>

          <custom-popup
            v-model="showMap"
            :cons="cons"
            hide-overlay
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-map-select-address`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('select_address_on_map')"
              />
            </template>
            <v-card :loading="mapLoading" class="col-12">
              <div class="px-5">
                <v-row>
                  <v-col cols="12" md="6">
                    <city-selector
                      v-model="geoLocation"
                      :search-fn="
                        () => {
                          this.search();
                        }
                      "
                    ></city-selector>
                  </v-col>
                  <v-col class="" cols="12" md="6">
                    <div>
                      <div class="rowinfo">
                        <v-autocomplete
                          v-model="geom"
                          :items="suggests"
                          class="contentinfo"
                          :search-input.sync="searchTitle"
                          append-icon="mdi-map-marker"
                          append-outer-icon="mdi-magnify"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          item-text="address"
                          item-value="geom"
                          :label="$t('search_address')"
                          outlined
                          @keypress.enter="search"
                          @click:append-outer="search"
                          @input="updateLocationFromAutocomplete"
                        >
                          <template
                            v-if="suggests.length > 0"
                            v-slot:item="data"
                          >
                            <v-list style="border-bottom: 1px solid #7e8299">
                              <v-list-item-title
                                class="font-weight-bold mb-2"
                                >{{ data.item.title }}</v-list-item-title
                              >
                              <v-list-item-subtitle class="mt-2"
                                >{{ data.item.address }} ,
                                {{ data.item.region }}</v-list-item-subtitle
                              >
                            </v-list>
                          </template>
                        </v-autocomplete>
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-coordinates`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('search_address')"
                        />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="data.coordinates[1]"
                      :label="$t('northern_coordinates')"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      v-model="data.coordinates[0]"
                      :label="$t('eastern_coordinates')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <p class="mt-5 font-weight-bold">
                  <span><v-icon color="red">mdi-map-marker</v-icon></span>
                  {{ data.address || $t("no_address_selected") }}
                </p>

                <mapir
                  v-if="data?.coordinates"
                  :apiKey="apiKey"
                  :center="data?.coordinates"
                  :zoom="zoomMap"
                  class="col-12"
                  style="width: 100%; height: 500px"
                  @click="getlatLng"
                >
                  <mapNavigationControl
                    :showUserLocation="true"
                    position="top-right"
                  />
                  <mapGeolocateControl
                    position="top-right"
                    show-user-location
                    track-user-location
                  />
                  <mapMarker
                    :coordinates.sync="data.coordinates"
                    color="red"
                    draggable
                    kind="marker"
                  >
                    <template v-slot:marker>
                      <v-icon>mdi-map-marker</v-icon>
                    </template>
                  </mapMarker>
                </mapir>
              </div>
            </v-card>
          </custom-popup>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfoWrapper from "./helpAcordion/HelpInfoWrapper.vue";
import HelpInfo from "./helpAcordion/HelpInfo.vue";
import axios from "axios";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import SuggestText from "../../../components/SuggestBox/suggestInput";
import IconPicker from "../../../components/IconPicker";
import CitySelector from "@/view/components/citySelector";
import ExtraFileds from "../../../components/Product/extraFileds";

export default {
  name: "textCards",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    ExtraFileds,
    CitySelector,
    IconPicker,
    SuggestText,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
  },

  props: {
    data: {
      default: () => ({
        location: "",
        coordinates: null,
        address: "",
        phoneNumber: [{ number: "" }],
        extraFields: [],
      }),
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "textCards",
      coordinates: { n: "", e: "" },
      coor: [51.672817, 32.657566],
      searchTitle: "",
      showMap: false,
      geom: null,
      suggests: [],
      fieldsInclude: [
        "qr.cardVisit",
        "qr.name.edit",
        'qr.cardVisitPro',
        'qr.name.edit.pro',
        'qr.name.id.edit.pro',
        'qr.create.cardVisitProModel',
        'qr.create.visitcardpro',
        "qr.name.id.edit",
        "qr.create.models",
        "qr.create.businessPage",
        "modelsList.edit",
        "qr.bShop",
        "qr.name.editBShop",
        "qr.name.id.editBShop",
        "qr.appointment",
        "qr.name.appointment",
        "qr.name.id.appointment",
        "qr.menu",
        "qr.name.editMenu",
        "qr.name.id.editMenu",
      ],
      mapLoading: false,
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      province: [],
      city: [],
      zoomMap: 15,
      geoLocation: {
        city: undefined,
        province: undefined,
      },
      phoneNumberText: [],
      showCompanyNumberName: false,
    };
  },

  computed: {
    urlRules() {
      return [(value) => this.isURL(value) || this.$t("rule_link")];
    },
    cons() {
      return {
        title: this.$t("select_address_on_map"),
      };
    },
    getCenter() {
      return this.data.center ?? [51.420296, 35.732379];
    },
    containFields() {
      return this.fieldsInclude.includes(this.$route.name);
    },
  },

  watch: {
    geom: function (val) {
      if (val) {
        this.updateLocationFromAutocomplete(val);
      }
    },
    showMap(val) {
      if (val) {
        if (!this.data.coordinates || this.data.coordinates.length <= 0) {
          this.data.coordinates = this.getCenter;
        }
      }
    },
    geoLocation: {
      handler(val) {
        if (val.province && Object.keys(val.province).length > 0) {
          this.data.coordinates = [
            val.province.latitude,
            val.province.longitude,
          ];
          this.getlatLng({
            actualEvent: {
              lngLat: {
                lng: this.data?.coordinates[1] || 51.672817,
                lat: this.data?.coordinates[0] || 32.657566,
              },
            },
          });
          this.zoomMap = 13;
        }
      },
      deep: true,
    },
    data: {
      deep: true,
      handler(val) {
        if (!val.coordinates) {
          this.data.coordinates = [51.672817, 32.657566];
        }
        if (!val.address) {
          this.$set(this.data, "address", "");
        }
      },
    },
  },

  methods: {
    isURL(str) {
      const regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      const without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      }
      return false;
    },

    updateLocationFromAutocomplete(geom) {
      if (geom && geom.address) {
        // this.$set(this.data, "location", geom.address);
        this.$set(this.data, "address", geom.address);
        this.$set(this.data, "coordinates", geom.coordinates);
      } else {
        // this.$set(this.data, "location", this.$t("no_address_selected"));
        this.$set(this.data, "address", this.$t("no_address_selected"));
      }
      this.getBySearch();
    },

    getlatLng(e) {
      this.mapLoading = true;
      this.data.coordinates = [
        e.actualEvent.lngLat.lng,
        e.actualEvent.lngLat.lat,
      ];

      axios({
        method: "GET",
        url: "https://map.ir/reverse",
        params: {
          lat: this.data?.coordinates[1] || 51.672817,
          lon: this.data?.coordinates[0] || 32.657566,
        },
        timeout: 15000,
        headers: {
          "x-api-key": this.apiKey,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.$set(
            this.data,
            "address",
            response.data.address || this.$t("no_address_selected"),
          );
          // this.$set(
          //   this.data,
          //   "location",
          //   response.data.address || this.$t("no_address_selected")
          // );
          // console.log("data.location after getlatLng:", this.data.location);
        })
        .catch((error) => {
          this.mapLoading = false;
          console.error(
            "Reverse API Error:",
            error.response?.data || error.message,
          );
          console.error("Reverse API Status:", error.response?.status);
          if (error.response?.status === 401) {
            this.$toast.error(this.$t("api_unauthorized"));
          } else {
            this.$toast.error(this.$t("location_not_found"));
            // this.$set(this.data, "location", this.$t("no_address_selected"));
            this.$set(this.data, "address", this.$t("no_address_selected"));
          }
        });
    },

    search() {
      this.mapLoading = true;
      const filter = `city eq ${this.geoLocation.province?.name || ""}`;

      axios
        .post(
          "https://map.ir/search/v2/autocomplete",
          {
            text: this.searchTitle || this.$t("region"),
            $filter: filter,
            $select: "poi,roads,neighborhood,county",
          },
          {
            timeout: 15000,
            headers: {
              "x-api-key": this.apiKey,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          this.mapLoading = false;
          this.suggests = response.data.value || [];
          if (this.suggests.length > 0 && this.suggests[0].geom?.coordinates) {
            this.data.center = this.suggests[0].geom.coordinates;
          }
          this.searchTitle = "";
        })
        .catch((error) => {
          this.mapLoading = false;
          console.error(
            "Search API Error:",
            error.response?.data || error.message,
          );
          console.error("Search API Status:", error.response?.status);
          if (error.response?.status === 401) {
            this.$toast.error(this.$t("api_unauthorized"));
          } else {
            this.$toast.error(this.$t("location_not_found"));
          }
        });
    },

    getBySearch() {
      if (!this.geom || !this.geom.coordinates) {
        this.$toast.error(this.$t("no_location_selected"));
        return;
      }
      this.mapLoading = true;
      this.data.coordinates = this.geom.coordinates;
      axios({
        method: "GET",
        url: "https://map.ir/reverse",
        params: {
          lat: this.data?.coordinates[1] || 51.672817,
          lon: this.data?.coordinates[0] || 32.657566,
        },
        timeout: 15000,
        headers: {
          "x-api-key": this.apiKey,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.$set(
            this.data,
            "address",
            response.data.address || this.$t("no_address_selected"),
          );
          // this.$set(
          //   this.data,
          //   "location",
          //   response.data.address || this.$t("no_address_selected")
          // );
          // console.log("data.location after getBySearch:", this.data.location);
        })
        .catch((error) => {
          this.mapLoading = false;
          console.error(
            "getBySearch Error:",
            error.response?.data || error.message,
          );
          console.error("getBySearch Status:", error.response?.status);
          if (error.response?.status === 401) {
            this.$toast.error(this.$t("api_unauthorized"));
          } else {
            this.$toast.error(this.$t("location_not_found"));
            // this.$set(this.data, "location", this.$t("no_address_selected"));
            this.$set(this.data, "address", this.$t("no_address_selected"));
          }
        });
    },

    // openNavigator() {
    //   if (!this.data.coordinates) {
    //     this.$toast.error(this.$t("no_location_selected"));
    //     return;
    //   }
    //   const [lon, lat] = this.data.coordinates;
    //   const url = `geo:${lat},${lon}?q=${lat},${lon}(${
    //     this.data.address || "Location"
    //   })`;
    //   window.open(url, "_blank");
    // },

    addPhone() {
      this.data.phoneNumber.push({
        number: "",
      });
    },

    removePhone(index) {
      if (this.data.phoneNumber.length === 1) {
        this.data.phoneNumber[0].number = "";
      } else {
        this.data.phoneNumber.splice(index, 1);
      }
    },

    removeLocation() {
      this.$set(this.data, "coordinates", [null, null]);
      this.$set(this.data, "address", "");
      // this.$set(this.data, "location", "");
    },

    showPhoneNumberText(index) {
      if (this.phoneNumberText.includes(index)) {
        this.phoneNumberText.splice(this.phoneNumberText.indexOf(index), 1);
      } else {
        this.phoneNumberText.push(index);
      }
    },
  },
};
</script>

<style scoped></style>
